import { Component } from 'vue-property-decorator';
import { TextArea } from 'streamlabs-beaker';
import SharedTextSettings from './SharedTextSettings.vue';
import EditorApi from '@/apis/editor-api';
import { EModalName } from '@/helpers/modal';
import EditorBase from '../EditorBase';

@Component({
  components: {
    STextArea: TextArea,
    SharedTextSettings,
  },
})
export default class StreamLabelSettings extends SharedTextSettings {
  openStreamLabelModal() {
    this.$modal.show(EModalName.streamLabel);
  }
}
